import { Folder as F, Id, Identifiable } from "@planzone/dto";

function getSelectedFolder(
  folder: Identifiable<F>,
  id: Id,
): Identifiable<F> | null {
  return folder.uuid === id
    ? folder
    : folder.children.reduce<Identifiable<F> | null>(
        (selectedFolder, child) =>
          !!selectedFolder
            ? selectedFolder
            : child.type === "folder"
              ? getSelectedFolder(child, id)
              : selectedFolder,
        null,
      );
}

export { getSelectedFolder };
